<template>
  <div>

    <!-- Lokale Beurteilung -->

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="isRequired">
      <validation-provider tag="div"
                           :name="path + '.lokale_beurteilung_residualstatus'"
                           :ref="path + '.lokale_beurteilung_residualstatus'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_RESIDUAL_STATUS_LOCALE') + ' *'"
          v-model="model.lokale_beurteilung_residualstatus"
          :items="ResidualstatusTypes"
          outlined
          :disabled="isDisabled"
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="!isRequired">
      <validation-provider tag="div"
                           :name="path + '.lokale_beurteilung_residualstatus'"
                           :ref="path + '.lokale_beurteilung_residualstatus'"
                           rules=""
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_RESIDUAL_STATUS_LOCALE')"
          v-model="model.lokale_beurteilung_residualstatus"
          :items="ResidualstatusTypes"
          outlined
          clearable
          :disabled="isDisabled"
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Gesamtbeurteilung -->

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.gesamtbeurteilung_residualstatus'"
                           :ref="path + '.gesamtbeurteilung_residualstatus'"
                           rules=""
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_RESIDUAL_STATUS_TOTAL')"
          v-model="model.gesamtbeurteilung_residualstatus"
          :items="ResidualstatusTypes"
          outlined
          clearable
          :disabled="isDisabled"
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'

export default {
  name: "Residualstatus",
  mixins: [metaData],
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    formKey: {
      type: String
    }
  },
  data () {
    return {
      model: {},
      ResidualstatusTypes: null
    }
  },
  created () {
    this.ResidualstatusTypes = this.formsMetaData.ResidualstatusTypes
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
